import checkout from "./form";

const {
  formField: {
    asignatura,
    distribucion_grupo,
    estudiante,
    estudiantes,
    profesor,
  },
} = checkout;

const initialValues = {
  [distribucion_grupo.name]: "",
  [profesor.name]: "",
  [asignatura.name]: "",
  [estudiante.name]: "",
  [estudiantes.name]: [],
};
export default initialValues;
